"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports._resetSimulationProduction = exports._getProduction = void 0;
const axios_1 = __importDefault(require("axios"));
const get_from_localstorage_1 = require("utils/get-from-localstorage");
const error_response_1 = require("utils/error-response");
const _getProduction = ({ year, month }) => __awaiter(void 0, void 0, void 0, function* () {
    const url = String(process.env.API_ENDPOINT) + '/transaction/production';
    const config = {
        params: { month, year },
        headers: {
            'X-User-Token': get_from_localstorage_1.getFromLocalStorage.token(),
        },
    };
    try {
        const response = yield axios_1.default.get(url, config);
        return response.data;
    }
    catch (e) {
        const { errorCode, errorMessage, isError } = (0, error_response_1.errorResponse)(e);
        return {
            isError,
            errorCode,
            errorMessage,
            dataBrand: [],
            dataContractorPit: [],
            dataTotal: [],
        };
    }
});
exports._getProduction = _getProduction;
const _resetSimulationProduction = ({ year, month }) => __awaiter(void 0, void 0, void 0, function* () {
    const url = String(process.env.API_ENDPOINT) + '/transaction/production';
    const config = {
        headers: {
            'X-User-Token': get_from_localstorage_1.getFromLocalStorage.token()
        }
    };
    try {
        const { data } = yield axios_1.default.post(url, { year: year.toString(), month }, config);
        return {
            isError: data.isError,
            errorCode: data.errorCode,
            errorMessage: data.errorMessage
        };
    }
    catch (e) {
        const { errorCode, errorMessage, isError } = (0, error_response_1.errorResponse)(e);
        return {
            isError,
            errorCode,
            errorMessage
        };
    }
});
exports._resetSimulationProduction = _resetSimulationProduction;
